import { apiClient } from './axios';

export interface QualityConfig {
  id: string;
  name: string;
  prompt: string;
  model_name: string;
  temperature: number;
  rubric: Record<string, unknown>;
  rubric_version: string;
  is_default: boolean;
  inject_current_date: boolean;
  include_tool_executions: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateQualityConfigInput {
  name: string;
  prompt: string;
  model_name?: string;
  temperature?: number;
  rubric: Record<string, unknown>;
  rubric_version: string;
  is_default?: boolean;
  inject_current_date?: boolean;
  include_tool_executions?: boolean;
}

export type UpdateQualityConfigInput = Partial<CreateQualityConfigInput>;

export const qualityConfigsApi = {
  list: async (): Promise<QualityConfig[]> => {
    const response = await apiClient.get<QualityConfig[]>('/quality-configs');
    return response.data;
  },
  getById: async (id: string): Promise<QualityConfig> => {
    const response = await apiClient.get<QualityConfig>(`/quality-configs/${id}`);
    return response.data;
  },
  create: async (data: CreateQualityConfigInput): Promise<QualityConfig> => {
    const response = await apiClient.post<QualityConfig>('/quality-configs', data);
    return response.data;
  },
  update: async (id: string, data: UpdateQualityConfigInput): Promise<QualityConfig> => {
    const response = await apiClient.put<QualityConfig>(`/quality-configs/${id}`, data);
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/quality-configs/${id}`);
  },
};
